<template>
  <div>
    <Header :title="'スカウト'" />
    <div class="boss-admin-container clearfix">
      <sidebar />
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'
import { mapActions } from 'vuex'

export default {
  components: {
    Sidebar,
    Header
  },
  created () {
    this.storeScoutDisplayItems()
  },
  methods: {
    ...mapActions('settings', [
      'storeScoutDisplayItems'
    ])
  }
}
</script>
